export function MetricCard ({ label, value, detail, icon, tone = 'primary' }) {
  return (
    <article className={`gateway-stat-card tone-${tone}`}>
      <div className="gateway-stat-head">
        <span>{label}</span>
        <i className={`fa-solid ${icon}`} />
      </div>
      <strong>{value}</strong>
      <small>{detail}</small>
    </article>
  )
}